export default __webpack_public_path__ + "static/media/sistema_di_segnalazioni_fcsi_whistleblowing_ITA.056edb71.pdf";